import React, { Key, useMemo } from 'react';
import useTranslate from '~/hooks/useTranslate';
import {
  Box,
  Button,
  Card,
  Center,
  Table,
  Typography,
} from '@qred/components-library';
import styled from 'styled-components';
import { useAuth0 } from '@auth0/auth0-react';
import { PageHeader } from '@qred/qit-ui';

const StyledTr = styled.tr`
  td:last-child {
    text-align: right;
  }
`;

const InvoicePage = () => {
  const t = useTranslate();
  const { isAuthenticated } = useAuth0();
  const showNewStyles = !isAuthenticated;

  const tableElements = useMemo(
    () => [
      { label: t('Invoices.Status'), value: 'New' },
      { label: t('DueDate'), value: '2024-10-31' },
      { label: t('Invoices.BankTransfer'), value: '5099-1884' },
      { label: t('Invoices.Ocr'), value: '10040202' },
    ],
    []
  );

  return (
    <>
      {!showNewStyles && (
        <Box mb="2.5em" mt="1.5em">
          <PageHeader pageTitle="Qredster AB" />
        </Box>
      )}
      <Card>
        <Typography
          component="p"
          size="xl"
          lineHeight="xl"
          weight={600}
          mt={24}
          mb={24}
        >
          {t('Invoices.InvoiceAmount')}: 23333kr
        </Typography>
        <Typography element="p" size="md" lineHeight="md" weight={500} mb={24}>
          {t('Dashboard.OverDueSentence2', { date: '2024-10-01' })}
        </Typography>
        <Table>
          <tbody>
            {tableElements.map((element) => (
              <StyledTr key={element.label as Key}>
                <td>
                  <Typography>{element.label}:</Typography>
                </td>
                <td>
                  <Typography>{element.value}</Typography>
                </td>
              </StyledTr>
            ))}
          </tbody>
        </Table>
        <Center>
          <Button size="xl">{t('Dashboard.PayInvoice')}</Button>
        </Center>
      </Card>
    </>
  );
};

export default InvoicePage;
